/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchHelperReset = {
    /**
     * Reset all facets
     */
    resetFacets() {
        this.lastVisitedCategoryPath = this.currentCategoryPath;
        this.facets = [];
        this.selectedFacets = [];
    },
    /**
     * Reset products
     */
    resetProducts() {
        this.products = [];
        this.productsTotal = null;
        this.pagesTotal = null;
        this.pagesCurrent = 1;
        this.pagesLoaded = [];
    }
}

export default liveSearchHelperReset;
